export var DYN_FLAG;
(function (DYN_FLAG) {
    DYN_FLAG["WORK"] = "WORK";
    DYN_FLAG["EXTRA"] = "EXTRA";
})(DYN_FLAG || (DYN_FLAG = {}));
export var ColumnGroupTypes;
(function (ColumnGroupTypes) {
    ColumnGroupTypes["UserData"] = "UserData";
    ColumnGroupTypes["PeriodNormGroup"] = "PeriodNormGroup";
    ColumnGroupTypes["IndividualNormGroup"] = "IndividualNormGroup";
    ColumnGroupTypes["ActualGroup"] = "ActualGroup";
    ColumnGroupTypes["WorkTimeGroup"] = "WorkTimeGroup";
    ColumnGroupTypes["CalculatedWorkHours"] = "CalculatedWorkHours";
    ColumnGroupTypes["FreeTimeTransfer"] = "FreeTimeTransfer";
    ColumnGroupTypes["FreeDays"] = "FreeDays";
    ColumnGroupTypes["Absences"] = "Absences";
})(ColumnGroupTypes || (ColumnGroupTypes = {}));
export var ConstantColumns;
(function (ConstantColumns) {
    ConstantColumns["UserName"] = "UserName";
    ConstantColumns["UserCode"] = "UserCode";
    ConstantColumns["DepartmentName"] = "DepartmentName";
    ConstantColumns["DepartmentCode"] = "DepartmentCode";
    ConstantColumns["ProfessionName"] = "ProfessionName";
    ConstantColumns["PeriodNorm"] = "PeriodNorm";
    ConstantColumns["UserActual"] = "UserActual";
    ConstantColumns["IndividualNorm"] = "IndividualNorm";
    ConstantColumns["WorkTime"] = "WorkTime";
    ConstantColumns["ExtraWork"] = "ExtraWork";
    ConstantColumns["Training"] = "Training";
    ConstantColumns["Watch"] = "Watch";
    ConstantColumns["ContractTransferedFreeTime"] = "ContractTransferedFreeTime";
    ConstantColumns["ContractUsedFreeTime"] = "ContractUsedFreeTime";
    ConstantColumns["ContractUnusedFreeTime"] = "ContractUnusedFreeTime";
    ConstantColumns["FreeDays"] = "FreeDays";
    ConstantColumns["OverUnder"] = "OverUnder";
    ConstantColumns["ContractOverUnder"] = "ContractOverUnder";
})(ConstantColumns || (ConstantColumns = {}));
